import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
  name: 'CustomDatePipe'
})
export class CustomDatePipe implements PipeTransform {
  transform(value: string, format: any): any {
    // const formattedDate = moment(value, 'DD-MM-YYYY HH:mm:ss Z').format('D/M/YYYY, h:mm a');
    if(format === 'D-M-YYYY'){
      if(value){
        return moment(value, 'DD-MM-YYYY HH:mm:ss Z').format('DD-MM-YYYY');
      }else{
        return ''
      } 
    }else if(format === 'MMMM'){
      return moment(value, 'DD-MM-YYYY HH:mm:ss Z').format(format)
    }
    else if(format === 'HH:mm:ss'){
      return moment(value, 'DD-MM-YYYY HH:mm:ss Z').format('HH:mm:ss');
    }
    else{
      if(value){
        return moment(value, 'DD-MM-YYYY HH:mm:ss Z').format('DD-MM-YYYY, hh:mm a');
      }else{
        return ''
      } 
    }
  }
}
